import React from 'react';
import { LandmarkIcon, StarIcon, ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function TrustBar() {
  return <div className="w-full bg-white border-y border-gray-100 py-6 md:py-8 shadow-sm relative z-20" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-195">
        <FadeIn className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-4" data-id="element-196">
          {/* Item 1: Reviews */}
          <div className="flex items-center justify-center flex-1 gap-3" data-id="element-197">
            <img src="https://cdn.magicpatterns.com/uploads/6V3PK5rxtr5xmZxaw5G5yP/advieskeuze_lr.png" alt="Advieskeuze" className="h-6 md:h-7 object-contain" data-id="element-198" />
            <div className="flex flex-col items-center md:items-start" data-id="element-199">
              <div className="flex gap-0.5 mb-0.5" data-id="element-200">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-gold text-gold" data-id="element-201" />)}
              </div>
              <span className="font-bold text-navy text-xs md:text-sm" data-id="element-202">
                9.8 / 10
              </span>
            </div>
          </div>

          {/* Divider (Desktop) */}
          <div className="hidden md:block w-px h-12 bg-gray-200" data-id="element-203"></div>

          {/* Item 2: Banken */}
          <div className="flex items-center justify-center flex-1 gap-3" data-id="element-204">
            <div className="w-10 h-10 rounded-full bg-navy/5 flex items-center justify-center flex-shrink-0" data-id="element-205">
              <LandmarkIcon className="w-5 h-5 text-navy" data-id="element-206" />
            </div>
            <span className="font-bold text-navy text-sm md:text-base" data-id="element-207">
              Ruim 30 geldverstrekkers
            </span>
          </div>

          {/* Divider (Desktop) */}
          <div className="hidden md:block w-px h-12 bg-gray-200" data-id="element-208"></div>

          {/* Item 3: AFM */}
          <div className="flex items-center justify-center flex-1 gap-3" data-id="element-209">
            <div className="w-10 h-10 rounded-full bg-navy/5 flex items-center justify-center flex-shrink-0" data-id="element-210">
              <ShieldCheckIcon className="w-5 h-5 text-navy" data-id="element-211" />
            </div>
            <span className="font-bold text-navy text-sm md:text-base" data-id="element-212">
              AFM-geregistreerd
            </span>
          </div>

          {/* Divider (Desktop) */}
          <div className="hidden md:block w-px h-12 bg-gray-200" data-id="element-213"></div>

          {/* Item 4: Erkend Adviseur */}
          <div className="flex items-center justify-center flex-1 gap-3" data-id="element-214">
            <div className="w-10 h-10 rounded-full bg-navy/5 flex items-center justify-center flex-shrink-0" data-id="element-215">
              <ShieldCheckIcon className="w-5 h-5 text-navy" data-id="element-216" />
            </div>
            <span className="font-bold text-navy text-sm md:text-base" data-id="element-217">
              Erkend Adviseur
            </span>
          </div>
        </FadeIn>
      </div>
    </div>;
}